import type {
  ConnectorProject,
  ConnectorProjectApiResponse,
  ConnectorProjectListApiResponse,
  ConnectorProjectListResponse,
} from '../interfaces/connector.interface'
import {
  transformConnectorProjectFromApi,
  transformConnectorProjectListFromApi,
} from '../interfaces/connector-transform.util'
import { agentsApiSlice } from './agents-api.store'

const API_BASE = '/api/v1/connectors'

const connectorProjectEndpoints = agentsApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getConnectorProjects: builder.query<ConnectorProjectListResponse, string>({
      query: (connectionId) => `${API_BASE}/connections/${connectionId}/projects`,
      transformResponse: (response: ConnectorProjectListApiResponse) =>
        transformConnectorProjectListFromApi(response),
      providesTags: ['ConnectorProjects'],
    }),

    updateProjectActive: builder.mutation<
      ConnectorProject,
      { projectId: string; isActive: boolean }
    >({
      query: ({ projectId, isActive }) => ({
        url: `${API_BASE}/project-toggle/${projectId}`,
        method: 'PATCH',
        body: { is_active: isActive },
      }),
      transformResponse: (response: ConnectorProjectApiResponse) =>
        transformConnectorProjectFromApi(response),
      invalidatesTags: ['ConnectorProjects', 'Connectors'],
    }),
  }),
})

export const { useGetConnectorProjectsQuery, useUpdateProjectActiveMutation } =
  connectorProjectEndpoints
